import React from "react";
import { observer } from "mobx-react-lite";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { Box, Button, DataGrid, FlexColumn, FlexRowCenter } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import ExplorationPinnedImagesListItem from "../explorationPinnedImagesListItem/ExplorationPinnedImagesListItem";
import ExplorationPinnedImagesEmptyList from "../explorationPinnedImagesEmptyList/ExplorationPinnedImagesEmptyList";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const ExplorationPinnedImagesList = observer(() => {
	const {
		hasPinnedImages,
		isLoading,
		setOpenIframeDialog,
		explorationPinnedImagesStore,
		isOpenExplorationButtonAvailable,
	} = useManageFashionInspirationStore();

	if (isLoading) {
		return null;
	}

	return (
		<FlexColumn overflow="hidden">
			<FlexColumn overflow="auto" p={4}>
				{ hasPinnedImages ? (
					<DndProvider backend={HTML5Backend}>
						<DataGrid
							CardComponent={ExplorationPinnedImagesListItem}
							columns={2}
							spacing={2}
							store={explorationPinnedImagesStore}
						/>
					</DndProvider>
				) : (
					<ExplorationPinnedImagesEmptyList />
				)}
			</FlexColumn>
			{ isOpenExplorationButtonAvailable && (
				<FlexRowCenter
					borderTop={STANDARD_BORDER_STYLE}
					justifyContent="center"
					p={4}
				>
					<Button
						design="primary"
						onClick={setOpenIframeDialog}
						res="OpenExploration"
					/>
				</FlexRowCenter>
			)}
		</FlexColumn>
	);
});

export default ExplorationPinnedImagesList;
